<div class="receive-dialog card p-3">
    <div class="card-header">
        <div>
            <h2>Receber Acerto Avulso</h2>
            <p>Informe a data de pagamento antes de confirmar.</p>
        </div>
    </div>

    <mat-dialog-content class="card-body">
        <div class="summary-row">
            <span>Total recebido na Cobradora</span>
            <strong>R$ {{ total | number:'1.2-2' }}</strong>
        </div>

        <mat-form-field appearance="outline" class="w-100">
            <mat-label>Data de pagamento</mat-label>
            <input matInput [matDatepicker]="paymentDatePicker" [formControl]="paymentDate" />
            <mat-datepicker-toggle matSuffix [for]="paymentDatePicker"></mat-datepicker-toggle>
            <mat-datepicker #paymentDatePicker startView="multi-year"></mat-datepicker>
        </mat-form-field>
    </mat-dialog-content>

    <mat-dialog-actions class="card-footer">
        <button mat-button class="btn btn-outline-secondary" type="button" (click)="cancel()">Cancelar</button>
        <button mat-flat-button color="primary" class="btn btn-primary" type="button" (click)="confirm()">Confirmar</button>
    </mat-dialog-actions>
</div>
